import React from 'react';
import Widget from '../../../models/widget';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ContextMenu, Button, DropdownItem, LinkWithActions } from '@weezevent/nacre';
import NavTitle from './NavTitle';
import ModalIntegrationCode from '../../../pages/widgets/modal_integration_code/modalIntegrationCode';
import Style from './style/context-menu.module.css';

export default function WidgetContextMenu({ organization, context, usages, footerCtaLabel, goBackLabel }) {
    const { t } = useTranslation();
    const history = useHistory();
    const [search, setSearch] = React.useState(null);
    const [showModal, setShowModal] = React.useState(false);
    const tooltipUrl = `${window.weezConfig.api.widgetUrl}/ticket/${context.widget_key}`;

    const [widgets] = Widget.useApiModel(
        {
            organizationId: organization.id,
            query: {
                search,
                usage__in: usages
            }
        },
        [organization, search, usages]
    );

    const defaultTooltipProps = {
        margin: false,
        triggerOnHover: true,
        position: 'top-start'
    };

    return (
        <>
            {showModal && <ModalIntegrationCode widget={context} code={showModal} displayCode={setShowModal} />}
            <ContextMenu
                withoutExternalLink
                catchphrase={<NavTitle title={t(goBackLabel)} link={`/ticket/O${organization.id}/personal_spaces`} />}
                title={context.name}
                linkComponent={<LinkWithActions tooltipText={<div className={Style['break-word']}>{tooltipUrl}</div>} url={tooltipUrl} position="top-start" />}
                titleTooltipProps={{ ...defaultTooltipProps, title: context.name, offset: [0, -5] }}
                cta={
                    <Button fluid onClick={() => setShowModal(true)} primary>
                        {t('ticket.personal_spaces.menu.cta-button')}
                    </Button>
                }
                switchMenuProps={{
                    text: t(goBackLabel),
                    footerText: t(footerCtaLabel),
                    onFooterClick: () => history.push(`/ticket/O${organization.id}/${context === 'personal_space' ? 'personal_spaces' : 'online_ticketing'}`),
                    searchProps: {
                        onChange: (synth, value) => {
                            setSearch(value);
                        },
                        handleReset: () => setSearch(''),
                        value: search,
                        placeholder: t('ticket.personal_spaces.menu.search_placeholder')
                    },
                    items: widgets?.map(widget => (
                        <DropdownItem
                            key={widget.id}
                            onClick={() =>
                                history.push(`/ticket/O${organization.id}/${context === 'personal_space' ? 'personal_spaces' : 'online_ticketing'}/${widget.id}/settings`)
                            }
                        >
                            {widget.name}
                        </DropdownItem>
                    ))
                }}
            />
        </>
    );
}
